import CheckBoxGroup from "./components/CheckBoxGroup/CheckBoxGroup";
import SubMenuContainer from "./components/SubMenuContainer/SubMenuContainer";
import stl from "./AsideSubMenu.module.css";
import RangeSliderWithInputs from "../../../../../UiKit/RangeSliderWithInputs/RangeSliderWithInputs";

function AsideSubMenu({
  openedFilter,
  handleFilterChange,
  handleCloseFilter,
  selectedOptions,
  tempSelectedOptions,
  handleSearch,
}) {

  const componentRenderer = () => {
    const rangeFilters = ["year", "odometer", "sellingprice", "monthly_installment"];
    if (rangeFilters.includes(openedFilter?.filterField)) {
      const selectedValue = selectedOptions.find(
        (option) => option?.filterField === openedFilter?.filterField
      );
      return (
        <RangeSliderWithInputs
          minValue={openedFilter.range_values.start}
          maxValue={openedFilter.range_values.end}
          step={
            openedFilter?.filterField === "year"
              ? 1
              : openedFilter.range_values.gap
          }
          selectedValue={[
            selectedValue?.range_values?.from
              ? selectedValue?.range_values?.from.toString()
              : openedFilter.range_values.start.toString(),
            selectedValue?.range_values?.to
              ? selectedValue?.range_values?.to.toString()
              : openedFilter.range_values.end.toString(),
          ]}
          handleFilterChange={handleFilterChange}
          filter={openedFilter}
        />
      );
    }
    return (
      <CheckBoxGroup
        tempSelectedOptions={tempSelectedOptions}
        hasSubGroups={
          openedFilter?.filterField === "model_id" ||
          openedFilter?.filterField === "trim_id" ||
          openedFilter?.filterField === "options_list"
        }
        filterType={openedFilter?.type}
        carshape={openedFilter?.filterField === "car_shape_id"}
        searchable={
          openedFilter?.filterField === "make_id" ||
          openedFilter?.filterField === "model_id"
        }
        options={openedFilter?.values}
        onChange={handleFilterChange}
        fieldName={openedFilter?.filterField}
        selectedOptions={selectedOptions?.filter(
          (option) => option?.filterField === openedFilter?.filterField
        )}
        isColorFilter={
          openedFilter?.filterField === "color_id" ||
          openedFilter?.filterField === "interior_color_id"
        }
        handleCloseFilter={handleCloseFilter}
        filter={openedFilter}
        openedFilter={openedFilter}
      />
    );
  };

  return (
      <div
        className={[stl.container, openedFilter ? stl.openSubMenu : ""].join(
          " "
        )}>
        <SubMenuContainer
          count={null}
          selectedFiltersCount={0}
          name={openedFilter?.displayName}
          handleCloseFilter={handleCloseFilter}
          onClick={() => {
            const filteredSelectedOptions = selectedOptions.filter(
              (filter) => filter?.filterField !== openedFilter?.filterField
            );

            const finalSelectedOptions = [
              ...filteredSelectedOptions,
              ...tempSelectedOptions,
            ];
            if (tempSelectedOptions.length)
              window.lastClickedFilter = tempSelectedOptions;

            handleSearch(finalSelectedOptions);
          }}
          component={componentRenderer()}
        />
      </div>
  );
}

export default AsideSubMenu;
